import {defineMessages} from 'react-intl';

const messages = defineMessages({
    FILE_SELECT: {
        id: 'file.select.file.select',
        defaultMessage: 'Choose a file or drag it here'
    },
    FILE_DROP: {
        id: 'file.select.file.drop',
        defaultMessage: 'Drop the file'
    },
    NEW_ATTACHMENTS: {
        id: 'attachments.new',
        defaultMessage: 'New attachments'
    }
});

export default messages;
